import { tokens } from '../../../../theme/tokens';
import { AccordionConfig } from '../../../../types/accordion';
import { TemplateConfig } from '../../template-config.interface';

const ACCORDION_CONFIG: AccordionConfig[] = [
  {
    key: 'general',
    title: 'Información general',
    subtitle: 'Configuración básica del carousel',
    fields: ['title', 'format', 'text'],
    defaultOpen: true,
    color: tokens.colors.brands.blue[200]
  },
  {
    key: 'images',
    title: 'Imágenes del carousel',
    subtitle: 'Las 5 imágenes del contenido',
    fields: ['edit_image_1', 'edit_image_2', 'edit_image_3', 'edit_image_4', 'edit_image_5'],
    defaultOpen: true,
    color: tokens.colors.brands.blue[100],
    layout: 'grid'
  }
];

export const resumidoCarouselManoAMano: TemplateConfig = {
  id: 'mano-a-mano',
  clientId: 'RESUMIDO',
  title: 'Mano a mano',
  description: 'Contenido mano a mano',
  aspectRatio: 'vertical',
  image: 'https://media.backend.doer.ar/brands/assets/RESUMIDO/templates/thumbnails/carrusel-mano-a-mano-vertical.png',
  optimized_image:
    'https://media.backend.doer.ar/brands/assets/RESUMIDO/templates/thumbnails/optimized/carrusel-mano-a-mano-vertical.png',
  //  image: 'https://media.backend.doer.ar/brands/assets/RESUMIDO/templates/thumbnails/carrusel-mano-a-mano-wide.png',
  video: '',

  config: {
    renderer: 'accordion',
    accordionConfig: ACCORDION_CONFIG
  },

  formFields: [
    {
      key: 'title',
      label: 'Nombre del proyecto',
      type: 'input',
      placeholder: 'Nombre para identificar este asset',
      required: true
    },
    {
      key: 'text',
      label: 'Texto',
      type: 'input',
      placeholder: 'Texto descriptivo',
      required: true
    },
    {
      key: 'format',
      label: 'Formato de salida',
      type: 'select',
      required: true,
      options: [
        { value: 'vertical', label: 'Vertical (9:16)' },
        { value: 'wide', label: 'Wide (16:9)' },
        { value: 'both', label: 'Ambos formatos' }
      ]
    },
    {
      key: 'edit_image_1',
      label: 'Portada 1',
      type: 'image',
      placeholder: 'https://ejemplo.com/portada1.jpg',
      required: true
    },
    {
      key: 'edit_image_2',
      label: 'Portada 2',
      type: 'image',
      placeholder: 'https://ejemplo.com/portada2.jpg',
      required: true
    },
    {
      key: 'edit_image_3',
      label: 'Portada 3',
      type: 'image',
      placeholder: 'https://ejemplo.com/portada3.jpg',
      required: true
    },
    {
      key: 'edit_image_4',
      label: 'Portada 4',
      type: 'image',
      placeholder: 'https://ejemplo.com/portada4.jpg',
      required: true
    },
    {
      key: 'edit_image_5',
      label: 'Portada 5',
      type: 'image',
      placeholder: 'https://ejemplo.com/portada5.jpg',
      required: true
    }
  ],
  promptTemplate: `Haceme un asset "Carrusel Mano a Mano" en formato vertical y wide usando estas imágenes
1. "https://media.backend.doer.ar/brands/para-testear/resumido/01.jpg"
2. "https://media.backend.doer.ar/brands/para-testear/resumido/02.jpg"
3. "https://media.backend.doer.ar/brands/para-testear/resumido/03.jpg"
4. "https://media.backend.doer.ar/brands/para-testear/resumido/04.jpg"
5. "https://media.backend.doer.ar/brands/para-testear/resumido/05.jpg"`
};
